
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1314Dialog extends Serenity.EntityDialog<Report_1314Row, any> {
        protected getFormKey() { return Report_1314Form.formKey; }
        protected getIdProperty() { return Report_1314Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1314Row.localTextPrefix; }
        protected getNameProperty() { return Report_1314Row.nameProperty; }
        protected getService() { return Report_1314Service.baseUrl; }
        protected getDeletePermission() { return Report_1314Row.deletePermission; }
        protected getInsertPermission() { return Report_1314Row.insertPermission; }
        protected getUpdatePermission() { return Report_1314Row.updatePermission; }

        protected form = new Report_1314Form(this.idPrefix);

    }
}